import { ActionButton, SimpleText, XPReactNative, View, ScrollView, useMedia, Button, YStack } from '@my/ui'
import { color, MiscUtils } from '@my/util'
import { ChevronDown, ChevronUp } from '@tamagui/lucide-icons-2'
import { useState } from 'react'
const { FlatList } = XPReactNative

interface SavvyQuestion {
  question: string;
  source: string;
  domain: 
    | 'retirement'
    | 'protection'
    | 'tax'
    | 'debt'
    | 'goals'
    | 'estate'
    | 'behavioral'
    | 'investment'
    | 'cash flow';
  intent: string;
  lifecycle: 
    | 'new_client'
    | 'active'
    | 'milestone_approaching'
    | 'life_event'
    | 're_engagement';
}

// SuggestedQuestions Props
interface SuggestedQuestionsProps {
  suggestedQuestions: string[] | SavvyQuestion[];
  handleSubmit: (text: string) => void;
}

// SuggestedQuestions Component
const SuggestedQuestionsMobile: React.FC<SuggestedQuestionsProps> = ({
  suggestedQuestions,
  handleSubmit,
}) => {
  const [showQuestions, setShowQuestions] = useState(false);
  const toggleShowQuestions = () => setShowQuestions(curr => !curr);
  const questions = (suggestedQuestions?.slice(0, 2) || []).map((item, idx) => {
      const question = typeof item === 'string'
      ? item
      : typeof item === 'object'
        ? item['question']
        : '';
      return <ActionButton
        key={idx}
        unstyled
        onPress={() => handleSubmit(question)}
        borderColor={"#85c19d43"}
        minHeight={125}
        padding={5}
        borderWidth={1}
        borderRadius={10}
        width="100%"
        maxWidth={'100%'}
        height="auto"
        justifyContent="center"
        //style={{padding: '0 5px 0 5px'}}
        hoverStyle={{backgroundColor: 'rgb(240, 240, 240)'}}
        pressStyle={{backgroundColor: 'rgb(240, 240, 240)'}}
        backgroundColor="white"
        marginBottom={5}
        {...MiscUtils.ui.shadowGenerator(.07,2)}
      >
        <SimpleText fontSize={16} color={'#495057'}>
          {question}
        </SimpleText>
      </ActionButton>
  });
  const columnView = <YStack gap={5}>
    <Button 
      onPress={toggleShowQuestions}
      iconAfter={showQuestions ? ChevronDown : ChevronUp}
    ><Button.Text style={{fontSize: 14}}>
      {`${showQuestions ? 'Hide' : 'Show'} Suggested Questions`}
    </Button.Text></Button>
    <ScrollView
      gap={5}
      style={{
        ...(showQuestions ? {} : {display: 'none'}),
        width: '100%',
        marginBottom: 5,
        flexGrow: 0
        //maxHeight: '80%'
        //flexShrink: 1
      }}
      contentContainerStyle={{
        gap: 5,
        maxHeight: 260,
        marginBottom: 5
      }}
    >
      {questions}
    </ScrollView>
  </YStack>;
  return columnView;
}

const SuggestedQuestionsDesktop: React.FC<SuggestedQuestionsProps> = ({
  suggestedQuestions,
  handleSubmit,
}) => (
  <FlatList
    style={{
      width: '100%',
      marginBottom: 5,
    }}
    contentContainerStyle={{
      gap: 10,
      maxHeight: '80%',
      paddingBottom: 5
    }}
    data={suggestedQuestions?.slice(0, 2) ?? []}
    renderItem={({ item }) => {
      const question = typeof item === 'string'
      ? item
      : typeof item === 'object'
        ? item['question']
        : '';
      return <ActionButton
        unstyled
        padding={10}
        onPress={() => handleSubmit(question)}
        borderColor={"#85c19d43"}
        minHeight={55}
        borderWidth={1}
        borderRadius={10}
        width="100%"
        //maxWidth={500}
        height="auto"
        justifyContent="center"
        hoverStyle={{backgroundColor: 'rgb(240, 240, 240)'}}
        pressStyle={{backgroundColor: 'rgb(240, 240, 240)'}}
        {...MiscUtils.ui.shadowGenerator(.1,5)}
      >
        <SimpleText fontSize={16} color={'#495057'}>
          {question}
        </SimpleText>
      </ActionButton>
    }}
  />
)

export const SuggestedQuestions: React.FC<SuggestedQuestionsProps> = (props) => {
  const media = useMedia();
  return media['max-sm'] ? <SuggestedQuestionsMobile {...props} /> : <SuggestedQuestionsDesktop {...props} />
}